module.exports = __webpack_public_path__ + "img/sold_house.2090bc3c.svg";